module.exports={
  "id": "morning-essentials",
  "name": "Morning essentials",
  "subtext": "Kickstart your event (and your day) with an assortment of fresh pastries, fruits, and classic breakfast favorites.",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/o1rucu2xa8o3keckw6lc.jpg",
  "price": {
    "value": 29.0,
    "per_person": true
  },
  "menu": {
    "menu_sections": [
      {
        "id": "morning-essentials-includes",
        "title": "Includes",
        "description": "Baked goods such as bagels, croissants, danishes, muffins, and scones. Jam, cream cheese, and butter. Fresh fruit, smoked salmon lox, hard boiled eggs, variety of cheeses, and sliced ham. Comes with bottled orange and apple juices."
      },
      {
        "id": "morning-essentials-selections",
        "title": "Select up to 2",
        "min_selections": 1,
        "max_selections": 2,
        "items": [
          {
            "name": "Yogurt parfait with berries and granola",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Chia seed pudding with nut milk and berries",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Overnight oats made with seasonal fruits",
            "price": {
              "value": 0.0
            }
          }
        ]
      }
    ]
  },
  "description": "Baked goods such as bagels, croissants, danishes, muffins, and scones. Jam, cream cheese, and butter. Fresh fruit, smoked salmon lox, hard boiled eggs, variety of cheeses, and sliced ham. Comes with bottled orange and apple juices."
}
